import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'hpm',
} as IModuleProps;
